import React, { useState } from 'react'
import { tokens } from "../../../theme";
import {  MenuItem, SubMenu } from "react-pro-sidebar";
import { Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import AssessmentIcon from '@mui/icons-material/Assessment';
import InventoryIcon from '@mui/icons-material/Inventory';
import CastConnectedIcon from '@mui/icons-material/CastConnected';
import VerticalShadesClosedIcon from '@mui/icons-material/VerticalShadesClosed';
import EngineeringIcon from "@mui/icons-material/Engineering";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};


const DF = () => {
  const [selected, setSelected] = useState("Dashboard");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <>
                {/* <Item
                  title="Dashboard"
                  to="/dashboard"
                  icon={<HomeOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                /> */}
            
                    {/* <SubMenu
                      title="Graficos"
                      icon={<AssessmentIcon />}
                      style={{ color: colors.grey[300] }}
                    > */}
                      <Item
                        title="Graficos Produccion(VIDRIO)"
                        to="/graficos"
                        icon={<DonutLargeIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                      <Item
                        title="Grafico Movile"
                        to="/relatorioG"
                        icon={<DonutLargeIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                      <Item
                        title="Historial Chapa"
                        to="/view/historialChapa"
                        icon={<InventoryIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                      <Item
                        title="Orden de Produccion"
                        to="/view/ordenProduccionView"
                        icon={<AccessTimeIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                      <Item
                        title="Producción funcionarios"
                        to="/consultas/produccionfuncionarios"
                        icon={<EngineeringIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                      <Item
                        title="Stock General"
                        to="/view/stockview"
                        icon={<ReceiptOutlinedIcon />}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    {/* </SubMenu> */}
              </>
  )
}

export default DF
